var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './live-page.styles';
import { dictionary } from '@mf-cms/helpers';
let PLivePage = class PLivePage extends LitElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
        this.video = {};
        this.settings = {};
        this.stats = {};
    }
    static { this.styles = styles; }
    showQA(video) {
        return (video.enableQA &&
            (video.status == 'BROADCASTING' ||
                (video.status == 'PENDING' && video.allowQABeforeBroadcast) ||
                (video.status == 'FINISHED' && video.allowQAAfterBroadcast)));
    }
    async getStats(video) {
        const response = await fetch(`${process.env.STATS_API_URL}/liveview/${video.mediaId}`);
        const json = await response.json();
        return json;
    }
    async getVideo(id) {
        const response = await fetch(`${process.env.API_URL}/livestream/${id}?fields=any&access_token=${this.accessToken}`);
        const json = await response.json();
        return json[0];
    }
    async getSettings(id, culture) {
        const response = await fetch(`${process.env.API_URL}/settings?fields=any&access_token=${this.accessToken}&lang=${culture}`);
        const json = await response.json();
        return json;
    }
    async firstUpdated() {
        this.accessToken = window.getAccessToken();
        this.video = await this.getVideo(this.videoId);
        this.settings = await this.getSettings(this.video.mediaId, this.culture);
        this.stats = await this.getStats(this.video);
        this.interval = setInterval(() => {
            this.updateData();
        }, 10000);
    }
    disconnectedCallback() {
        clearInterval(this.interval);
        super.disconnectedCallback();
    }
    async updateData() {
        this.video = await this.getVideo(this.videoId);
        this.stats = await this.getStats(this.video);
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <!-- TODO: check if we should hide viewers before and after the broadcast --> <p-video-page culture=${this.culture} name=${this.video?.title} description=${this.video?.description} theater-modes viewers=${this.stats?.currentViewers?.total} ?dark=${this.dark} ?live=${this.video?.status == 'BROADCASTING'} hide-data date="${new Date(this.video?.liveAt).format('dd MMM yyyy', { showTime: false })} ${new Date(this.video?.liveAt).format('default', { showTimeOnly: true })}" > <div slot="player" class="player"> <slot name="player"></slot> </div> ${this.settings.allowSocialMedia ? html `
              <p-button
                target-dialog="p-share-dialog"
                color="border"
                slot="actions"
                ?dark=${this.dark}
              >
                <svg
                  slot="prefix"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-share"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5m-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
                  />
                </svg>
                ${dictionary(this.culture, 'general', 'share')}
              </p-button>
            `
            : ''}
        ${this.showQA(this.video)
            ? html `<p-button target-dialog="p-qa-dialog" color="primary" slot="actions"> <svg slot="prefix" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16" > <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" /> <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" /> </svg> ${dictionary(this.culture, 'qa', 'askAQuestion')} </p-button>`
            : ''}
      </p-video-page>
    `;
    }
};
__decorate([
    property({ type: String })
], PLivePage.prototype, "url", void 0);
__decorate([
    property({ type: String })
], PLivePage.prototype, "culture", void 0);
__decorate([
    property({ type: Number, attribute: 'video-id' })
], PLivePage.prototype, "videoId", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PLivePage.prototype, "dark", void 0);
__decorate([
    property()
], PLivePage.prototype, "video", void 0);
__decorate([
    property()
], PLivePage.prototype, "settings", void 0);
__decorate([
    property()
], PLivePage.prototype, "stats", void 0);
PLivePage = __decorate([
    customElement('p-live-page')
    /**
     * PVideoPage component
     *
     * @class PVideoPage
     * @typedef {PVideoPage}
     * @extends {LitElement}
     */
], PLivePage);
export { PLivePage };
